module.exports = __webpack_public_path__ + "img/20.be5667b7.jpg";